"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurCommunityPartners() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: row1Ref,
    isVisible: row1Visible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: row2Ref,
    isVisible: row2Visible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: pubRef,
    isVisible: pubVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const partnersRow1 = [{
    name: "Community Health Alliance",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700933/img/partner_health_alliance.png"
  }, {
    name: "Inclusive Education Hub",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700933/img/partner_education_hub.png"
  }, {
    name: "Neurodiverse Family Network",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700933/img/partner_family_network.png"
  }, {
    name: "City Respite Services",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700933/img/partner_city_respite.png"
  }, {
    name: "Advocacy First Group",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700933/img/partner_advocacy_first.png"
  }, {
    name: "Youth Empowerment Collective",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700933/img/partner_youth_collective.png"
  }];
  const partnersRow2 = [{
    name: "Local Caregiver Support",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700933/img/partner_caregiver_support.png"
  }, {
    name: "Bilingual Resource Center",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700933/img/partner_bilingual_center.png"
  }, {
    name: "Inclusive Play Spaces",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700933/img/partner_play_spaces.png"
  }, {
    name: "Family Wellness Partners",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700933/img/partner_wellness_partners.png"
  }, {
    name: "Community Outreach Alliance",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700933/img/partner_outreach_alliance.png"
  }, {
    name: "Special Needs Advocacy Org",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700933/img/partner_advocacy_org.png"
  }];
  const publications = [{
    name: "Nonprofit Today"
  }, {
    name: "Community Impact News"
  }, {
    name: "Family Advocacy Journal"
  }, {
    name: "Inclusive Living Magazine"
  }];
  return <section data-section-id="711" id="our-community-partners" className="bg-background text-foreground py-24 px-6 md:px-10">
      <div className="mx-auto max-w-7xl">
        {}
        <div ref={headerRef} className={`mx-auto max-w-2xl text-center transition-all duration-700 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <p className="font-default text-xs tracking-[0.25em] uppercase text-secondary">
            Our Trusted Network
          </p>
          <h2 className="font-default mt-5 text-6xl leading-[1.1] tracking-tight text-foreground">
            Building a <em className="italic font-light">stronger</em> community
          </h2>
          <p className="mt-5 font-default text-xl text-muted-foreground leading-relaxed">
            We are proud to partner with organizations that share our commitment to supporting neurodiverse families through advocacy and care.
          </p>
        </div>

        {}
        <div className="mt-16 h-px w-full bg-primary/20" aria-hidden="true" />

        {}
        <div ref={row1Ref} className="grid grid-cols-3 md:grid-cols-6 gap-y-10 md:gap-y-0 py-10 md:py-12">
          {partnersRow1.map((partner, i) => <div key={partner.name} data-index={i} className={`group flex items-center justify-center h-[100px] transition-all ease-out ${row1Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
          transitionDuration: "700ms",
          transitionDelay: row1Visible ? `${i * 80}ms` : "0ms"
        }}>
              <img src={partner.image} data-wvc-srcset={`${partner.image}-wvc-srcset`} data-wvc-sizes={`${partner.image}-wvc-sizes`} alt={partner.name} loading="lazy" decoding="async" className="max-h-16 max-w-[140px] md:max-w-[160px] w-auto object-contain opacity-60 grayscale transition-all duration-[400ms] ease-out group-hover:opacity-100 group-hover:grayscale-0 group-hover:scale-105" />
            </div>)}
        </div>

        {}
        <div className="h-px w-full bg-primary/20" aria-hidden="true" />

        {}
        <div ref={pubRef} className={`flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 py-10 transition-all duration-700 ease-out ${pubVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <span className="font-default italic text-base text-secondary">
            Featured in:
          </span>
          <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3">
            {publications.map((pub, i) => <span key={pub.name} data-index={i} className="font-default text-sm tracking-wide text-foreground/80 uppercase">
                {pub.name}
              </span>)}
          </div>
        </div>

        {}
        <div className="h-px w-full bg-primary/20" aria-hidden="true" />

        {}
        <div ref={row2Ref} className="grid grid-cols-3 md:grid-cols-6 gap-y-10 md:gap-y-0 py-10 md:py-12">
          {partnersRow2.map((partner, i) => <div key={partner.name} data-index={i} className={`group flex items-center justify-center h-[100px] transition-all ease-out ${row2Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
          transitionDuration: "700ms",
          transitionDelay: row2Visible ? `${i * 80}ms` : "0ms"
        }}>
              <img src={partner.image} data-wvc-srcset={`${partner.image}-wvc-srcset`} data-wvc-sizes={`${partner.image}-wvc-sizes`} alt={partner.name} loading="lazy" decoding="async" className="max-h-16 max-w-[140px] md:max-w-[160px] w-auto object-contain opacity-60 grayscale transition-all duration-[400ms] ease-out group-hover:opacity-100 group-hover:grayscale-0 group-hover:scale-105" />
            </div>)}
        </div>

        {}
        <div className="h-px w-full bg-primary/20" aria-hidden="true" />

        {}
        <div className="mt-12 flex justify-center">
          <Button asChild variant="link" className="text-secondary hover:text-secondary/80 font-default italic text-base tracking-wide p-0 h-auto">
            <Link to="/ConnectPage">
              Become a partner
              <ArrowRight className="ml-1 size-4" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}